import { SpinnerIcon } from '@phosphor-icons/react';

export function Spinner() {
  return (
    <div className="flex justify-center items-center h-96">
      <SpinnerIcon size={40} className="animate-spin" />
    </div>
  );
}
